import type { Joined, MyInvitation, WorkspaceAddress } from "@omnabase/shared";
import { api, ApiError } from "./api";
import { authClient } from "./auth";

/** M11 round one: the person's invitations (the welcome step, the chooser, Home's notice), Accept and Decline one at a time, auto-accept
 *  where the proof is strong, and the creation form's two calls. */
export const myInvitations = async () => (await api.get<{ invitations: MyInvitation[] }>("/api/v1/me/invitations")).invitations;
export const acceptInvitation = (id: string) => api.post<Joined>(`/api/v1/me/invitations/${encodeURIComponent(id)}/accept`, {});
export const declineInvitation = (id: string) => api.post<{ ok: true }>(`/api/v1/me/invitations/${encodeURIComponent(id)}/decline`, {});

/** Auto-accept (brief choice 4) only where the proof is strong: the invitation whose link the person followed and then proved the address
 *  for, or, for a person with no workspace yet, each open invitation on its own call (one failure stops none). Newest first, as listed. */
export async function autoAccept(followed: string | null, memberships: number): Promise<{ joined: Joined[]; followedFailed: boolean }> {
  if (followed) { try { return { joined: [await acceptInvitation(followed)], followedFailed: false }; } catch { return { joined: [], followedFailed: true }; } }
  if (memberships > 0) return { joined: [], followedFailed: false };
  const joined: Joined[] = [];
  for (const inv of (await myInvitations()).filter((i) => !i.expired)) { try { joined.push(await acceptInvitation(inv.id)); } catch { /* the next one still goes */ } }
  return { joined, followedFailed: false };
}

/** "Not for you? Leave": the library's own leave (the only owner cannot) */
export async function leaveWorkspace(organizationId: string): Promise<void> {
  const r = await authClient.organization.leave({ organizationId });
  if (r.error) throw new ApiError(r.error.status, r.error.code ?? "bad_request", r.error.message ?? "Could not leave");
}

export const checkWorkspaceAddress = (slug: string) => api.get<WorkspaceAddress>(`/api/v1/workspaces/address?slug=${encodeURIComponent(slug)}`);
export const createWorkspace = (body: { name: string; slug: string; termsVersion?: string; termsAccepted?: boolean }) => api.post<{ id: string; slug: string; name: string }>("/api/v1/workspaces", body);
